/**
 * @file   src\components\Introduction\ClientModal.js
 * @brief  This file is responsible for the view of client list for choosing clients for agents on sending the introduction.
 * @date   June, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React from "react";
import Modal from "react-bootstrap/Modal";
import { getInitials } from "../../helpers/common";

const ClientModal = (props) => {
  const clientList = props.clientList;
  const selectedClientId = props.selectedClientId;

  // Client selection radio button change event handler.
  const handleRadioButtonChange = (client) => {
    props.handleClientChange(client);
    props.onHide();
  };

  return (
    <Modal
      show
      centered
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      className="modal-right-aligned"
    >
      <Modal.Body className="">
        <div className=" position-relative">
          <div className="sub-heading-small position-relative mb-4">
            <a
              role="button"
              className="sub-heading-backbtn"
              href={void 0}
              onClick={props.onHide}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M10.1003 5.39966C10.3932 5.69256 10.3932 6.16743 10.1003 6.46032L5.31066 11.25H20.5C20.9142 11.25 21.25 11.5858 21.25 12C21.25 12.4142 20.9142 12.75 20.5 12.75H5.31066L10.1003 17.5397C10.3932 17.8326 10.3932 18.3074 10.1003 18.6003C9.80744 18.8932 9.33256 18.8932 9.03967 18.6003L2.96967 12.5303C2.82902 12.3897 2.75 12.1989 2.75 12C2.75 11.8011 2.82902 11.6103 2.96967 11.4697L9.03967 5.39966C9.33256 5.10677 9.80744 5.10677 10.1003 5.39966Z"
                  fill="#1B1C1E"
                />
              </svg>
            </a>
            Choose client
          </div>
          <div className="modal-choose-property modal-v-scroll">
            {clientList &&
              clientList.map((client) => {
                let { initials, backgroundColor } = getInitials(
                  client?.FirstName + " " + client?.LastName
                );
                return (
                  <label className="property-radio">
                    <input
                      type="radio"
                      name="check-box-option"
                      id={client?.ClientId}
                      value={client?.ClientId}
                      checked={
                        client?.ClientId == selectedClientId ? true : false
                      }
                      onClick={() => handleRadioButtonChange(client)}
                      onChange={() => {}}
                    />
                    <span>
                      <div className={"left-prof-wrap " + backgroundColor}>
                        {initials}
                      </div>
                      <div className="modal-wrap-info">
                        <h2 className="pb-0">
                          {client?.FirstName + " " + client?.LastName}
                        </h2>
                      </div>
                    </span>
                  </label>
                );
              })}
          </div>
          <div className="modal-choose-property-btnwrap">
            <button
              className="btn btn-secondary w-100"
              onClick={() => props.AddNewClient(true)}
            >
              Add Client
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default ClientModal;
